// Simple image alt text generator
export const generateImageAltText = (context, description) => {
  return description ? `${description} - ${context}` : `Image related to ${context}`;
};

// Meta description optimizer
export const optimizeMetaDescription = (content, maxLength = 160) => {
  // Remove HTML tags and extra whitespace
  const text = content.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  
  if (text.length <= maxLength) return text;
  
  // Try to end at a sentence
  const truncated = text.substring(0, maxLength);
  const lastPeriod = truncated.lastIndexOf('.');
  
  return lastPeriod > 0 
    ? truncated.substring(0, lastPeriod + 1)
    : truncated.substring(0, maxLength - 3) + '...';
}; 